import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, debounceTime } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { SlipId } from '../../../bet-generation/models';
import { IStake } from '../../../stake/models';
import { HideMinError } from '../../../stake/utils';
import { UnderMinimumStakePreCheckError } from '../../../validation/errors/pre-check/under-minimum-stake-pre-check-error';
import { selectLinearStakeErrorsFactory } from '../../../validation/selectors.linear';
import { IStakeErrorViewModel } from '../../models/stake-errors.model';

export interface IStakeErrors {
    hasInsufficientAmountError: boolean;
    minimumStakeErrors: UnderMinimumStakePreCheckError[];
}

@Injectable()
export class LinearStakeErrorsService {
    constructor(private store: Store<IBetslipRootState>) {}

    getStakeErrors$(slipKey: SlipId): Observable<IStakeErrors> {
        return this.store.select(selectLinearStakeErrorsFactory(slipKey)).pipe(debounceTime(5));
    }

    convertToViewModel(errors: IStakeErrors, stake: IStake | null, isNumpadOpen: boolean, hideInsufficentFunds?: boolean): IStakeErrorViewModel {
        const minStakeError = errors.minimumStakeErrors[0];

        const visibleMinStakeError =
            minStakeError && !HideMinError(Number(minStakeError.minimumStake), isNumpadOpen, stake?.actualStake ?? null) ? minStakeError : undefined;

        const hasInsufficientFunds = !hideInsufficentFunds && errors.hasInsufficientAmountError && typeof stake?.stake === 'number';

        return {
            hasStakeErrors: hasInsufficientFunds || !!visibleMinStakeError,
        };
    }
}
